import {
  canAffordPotion,
  canAffordWithCommon,
  canAffordWithSpecific,
} from "./potionAffordability";

export function hasKeyLevelAccess(key, maxUnlockedLevel = 1) {
  const required = Number(key?.minLevel) || 1;
  return (Number(maxUnlockedLevel) || 1) >= required;
}

export function canAffordKey(key, gemCounts = {}, maxUnlockedLevel = 1) {
  if (!hasKeyLevelAccess(key, maxUnlockedLevel)) return false;
  return canAffordPotion(key, gemCounts);
}

export { canAffordWithCommon, canAffordWithSpecific };
